import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import signup from '../assets/signupimage.png'
import '../style/signup.css'; // reuse existing styles or create a new one

const BasicInfoForm = () => {
  return (
    <section className='signup'>
      <Container>
        <Row className="align-items-center">
          {/* Form Section */}
          <Col lg={7} className="form-section p-4">
            <h2>
              Submit Your <em className="fw-semibold">Basic</em><br />Information
            </h2>

            <Form className="mt-4">
              <Form.Group className="mb-3">
                <Form.Label>Select</Form.Label>
                <Form.Select>
                  <option>Select</option>
                  <option>Option 1</option>
                  <option>Option 2</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3 photosupload">
                <Form.Label>Photos</Form.Label>
                <div className="d-flex align-items-center">
                  <Form.Control type="file" multiple />
                  <Button className="ms-2">+</Button>
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Street Address</Form.Label>
                <Form.Control type="text" />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Extended Address</Form.Label>
                <Form.Control type="text" placeholder="Extended Address" />
              </Form.Group>

              <Row className="mb-3">
                <Col>
                <Form.Label>City</Form.Label>
                  <Form.Control type="text" placeholder="City" />
                </Col>
                <Col>
                <Form.Label>State</Form.Label>
                  <Form.Control type="text" placeholder="State" />
                </Col>
                <Col>
                <Form.Label>Zip Required</Form.Label>
                  <Form.Control type="text" placeholder="Zip Required" />
                </Col>
              </Row>

              <Button href='/Firstlisting' type="submit" className="w-100 mt-3 btn btn-submit">
                Complete Setup
              </Button>
            </Form>
          </Col>

          {/* Image Section */}
          <Col lg={5} className="image-section text-center">
            <img
              src={signup}
              alt="Farmers Market"
              className="img-fluid rounded shadow"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BasicInfoForm;
